/* tslint:disable */
/* eslint-disable */
/**
 * HR Recruiter API — Complaints
 * OpenAPI спецификация для системы жалоб пользователей. Включает создание жалоб, управление статусами и админские операции. Самодостаточный файл для генерации и документации. 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@hr-recruiter.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface CloseComplaintRequest
 */
export interface CloseComplaintRequest {
    /**
     * Статус закрытия
     * @type {string}
     * @memberof CloseComplaintRequest
     */
    'status': CloseComplaintRequestStatus;
    /**
     * Обязательный комментарий разработчика
     * @type {string}
     * @memberof CloseComplaintRequest
     */
    'developerComment': string;
}

export const CloseComplaintRequestStatus = {
    FIXED: 'FIXED',
    SKIPPED: 'SKIPPED'
} as const;

export type CloseComplaintRequestStatus = typeof CloseComplaintRequestStatus[keyof typeof CloseComplaintRequestStatus];

/**
 * 
 * @export
 * @interface CloseComplaintResponse
 */
export interface CloseComplaintResponse {
    /**
     * ID жалобы
     * @type {number}
     * @memberof CloseComplaintResponse
     */
    'id': number;
    /**
     * Статус закрытия
     * @type {string}
     * @memberof CloseComplaintResponse
     */
    'status': CloseComplaintResponseStatus;
    /**
     * Комментарий разработчика
     * @type {string}
     * @memberof CloseComplaintResponse
     */
    'developerComment': string;
    /**
     * Дата закрытия
     * @type {string}
     * @memberof CloseComplaintResponse
     */
    'closedAt': string;
}

export const CloseComplaintResponseStatus = {
    FIXED: 'FIXED',
    SKIPPED: 'SKIPPED'
} as const;

export type CloseComplaintResponseStatus = typeof CloseComplaintResponseStatus[keyof typeof CloseComplaintResponseStatus];

/**
 * 
 * @export
 * @interface ComplaintDetailResponse
 */
export interface ComplaintDetailResponse {
    /**
     * ID жалобы
     * @type {number}
     * @memberof ComplaintDetailResponse
     */
    'id': number;
    /**
     * Полный текст жалобы
     * @type {string}
     * @memberof ComplaintDetailResponse
     */
    'text': string;
    /**
     * Email отправителя
     * @type {string}
     * @memberof ComplaintDetailResponse
     */
    'senderEmail': string;
    /**
     * 
     * @type {ComplaintStatus}
     * @memberof ComplaintDetailResponse
     */
    'status': ComplaintStatus;
    /**
     * Комментарий разработчика
     * @type {string}
     * @memberof ComplaintDetailResponse
     */
    'developerComment'?: string | null;
    /**
     * Дата закрытия
     * @type {string}
     * @memberof ComplaintDetailResponse
     */
    'closedAt'?: string | null;
    /**
     * Дата создания
     * @type {string}
     * @memberof ComplaintDetailResponse
     */
    'createdAt': string;
}


/**
 * 
 * @export
 * @interface ComplaintListItem
 */
export interface ComplaintListItem {
    /**
     * ID жалобы
     * @type {number}
     * @memberof ComplaintListItem
     */
    'id': number;
    /**
     * Email отправителя
     * @type {string}
     * @memberof ComplaintListItem
     */
    'senderEmail': string;
    /**
     * 
     * @type {ComplaintStatus}
     * @memberof ComplaintListItem
     */
    'status': ComplaintStatus;
    /**
     * Дата создания
     * @type {string}
     * @memberof ComplaintListItem
     */
    'createdAt': string;
}


/**
 * 
 * @export
 * @interface ComplaintPageResponse
 */
export interface ComplaintPageResponse {
    /**
     * Список жалоб на текущей странице
     * @type {Array<ComplaintListItem>}
     * @memberof ComplaintPageResponse
     */
    'content': Array<ComplaintListItem>;
    /**
     * Номер текущей страницы
     * @type {number}
     * @memberof ComplaintPageResponse
     */
    'page': number;
    /**
     * Размер страницы
     * @type {number}
     * @memberof ComplaintPageResponse
     */
    'size': number;
    /**
     * Общее количество элементов
     * @type {number}
     * @memberof ComplaintPageResponse
     */
    'totalElements': number;
    /**
     * Общее количество страниц
     * @type {number}
     * @memberof ComplaintPageResponse
     */
    'totalPages': number;
}
/**
 * Статус жалобы
 * @export
 * @enum {string}
 */

export const ComplaintStatus = {
    CREATED: 'CREATED',
    SENT: 'SENT',
    ERROR: 'ERROR',
    FIXED: 'FIXED',
    SKIPPED: 'SKIPPED'
} as const;

export type ComplaintStatus = typeof ComplaintStatus[keyof typeof ComplaintStatus];


/**
 * 
 * @export
 * @interface CreateComplaintRequest
 */
export interface CreateComplaintRequest {
    /**
     * Текст жалобы
     * @type {string}
     * @memberof CreateComplaintRequest
     */
    'text': string;
    /**
     * Email отправителя
     * @type {string}
     * @memberof CreateComplaintRequest
     */
    'senderEmail': string;
}
/**
 * 
 * @export
 * @interface CreateComplaintResponse
 */
export interface CreateComplaintResponse {
    /**
     * ID созданной жалобы
     * @type {number}
     * @memberof CreateComplaintResponse
     */
    'id': number;
    /**
     * 
     * @type {ComplaintStatus}
     * @memberof CreateComplaintResponse
     */
    'status': ComplaintStatus;
}


/**
 * Стандартный ответ об ошибке
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * Сообщение об ошибке
     * @type {string}
     * @memberof ErrorResponse
     */
    'message': string;
    /**
     * Список ошибок валидации
     * @type {Array<string>}
     * @memberof ErrorResponse
     */
    'errors'?: Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateComplaintRequest
 */
export interface UpdateComplaintRequest {
    /**
     * 
     * @type {ComplaintStatus}
     * @memberof UpdateComplaintRequest
     */
    'status'?: ComplaintStatus;
    /**
     * Комментарий разработчика
     * @type {string}
     * @memberof UpdateComplaintRequest
     */
    'developerComment'?: string;
}



/**
 * ComplaintsApi - axios parameter creator
 * @export
 */
export const ComplaintsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Закрывает жалобу с переводом в статус FIXED или SKIPPED. Требует обязательный комментарий разработчика. 
         * @summary Закрыть жалобу
         * @param {number} id ID жалобы
         * @param {CloseComplaintRequest} closeComplaintRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeComplaint: async (id: number, closeComplaintRequest: CloseComplaintRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('closeComplaint', 'id', id)
            // verify required parameter 'closeComplaintRequest' is not null or undefined
            assertParamExists('closeComplaint', 'closeComplaintRequest', closeComplaintRequest)
            const localVarPath = `/complaints/{id}/close`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(closeComplaintRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Создаёт новую жалобу от пользователя. Публичный endpoint без аутентификации. Жалоба автоматически ставится в очередь отправки в поддержку. 
         * @summary Создать жалобу
         * @param {CreateComplaintRequest} createComplaintRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComplaint: async (createComplaintRequest: CreateComplaintRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createComplaintRequest' is not null or undefined
            assertParamExists('createComplaint', 'createComplaintRequest', createComplaintRequest)
            const localVarPath = `/complaints`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createComplaintRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Получает детальную информацию о жалобе по ID. Включает полный текст жалобы и комментарий разработчика. 
         * @summary Получить жалобу по ID
         * @param {number} id ID жалобы
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComplaintById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getComplaintById', 'id', id)
            const localVarPath = `/complaints/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Пагинированный список жалоб для администраторов. Возвращает только метаданные без полного текста жалоб. 
         * @summary Получить список жалоб
         * @param {number} [page] Номер страницы (начиная с 0)
         * @param {number} [size] Размер страницы (максимум 100)
         * @param {ComplaintStatus} [status] Фильтр по статусу жалобы
         * @param {string} [senderEmail] Фильтр по email отправителя (точное совпадение)
         * @param {string} [sort] Сортировка (по умолчанию по дате создания, убывание)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComplaints: async (page?: number, size?: number, status?: ComplaintStatus, senderEmail?: string, sort?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/complaints`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (senderEmail !== undefined) {
                localVarQueryParameter['senderEmail'] = senderEmail;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Обновляет жалобу (только для администраторов). Позволяет изменить статус и добавить комментарий. 
         * @summary Обновить жалобу
         * @param {number} id ID жалобы
         * @param {UpdateComplaintRequest} updateComplaintRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateComplaint: async (id: number, updateComplaintRequest: UpdateComplaintRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateComplaint', 'id', id)
            // verify required parameter 'updateComplaintRequest' is not null or undefined
            assertParamExists('updateComplaint', 'updateComplaintRequest', updateComplaintRequest)
            const localVarPath = `/complaints/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateComplaintRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ComplaintsApi - functional programming interface
 * @export
 */
export const ComplaintsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ComplaintsApiAxiosParamCreator(configuration)
    return {
        /**
         * Закрывает жалобу с переводом в статус FIXED или SKIPPED. Требует обязательный комментарий разработчика. 
         * @summary Закрыть жалобу
         * @param {number} id ID жалобы
         * @param {CloseComplaintRequest} closeComplaintRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async closeComplaint(id: number, closeComplaintRequest: CloseComplaintRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CloseComplaintResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.closeComplaint(id, closeComplaintRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComplaintsApi.closeComplaint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Создаёт новую жалобу от пользователя. Публичный endpoint без аутентификации. Жалоба автоматически ставится в очередь отправки в поддержку. 
         * @summary Создать жалобу
         * @param {CreateComplaintRequest} createComplaintRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createComplaint(createComplaintRequest: CreateComplaintRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateComplaintResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createComplaint(createComplaintRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComplaintsApi.createComplaint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Получает детальную информацию о жалобе по ID. Включает полный текст жалобы и комментарий разработчика. 
         * @summary Получить жалобу по ID
         * @param {number} id ID жалобы
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getComplaintById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComplaintDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getComplaintById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComplaintsApi.getComplaintById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Пагинированный список жалоб для администраторов. Возвращает только метаданные без полного текста жалоб. 
         * @summary Получить список жалоб
         * @param {number} [page] Номер страницы (начиная с 0)
         * @param {number} [size] Размер страницы (максимум 100)
         * @param {ComplaintStatus} [status] Фильтр по статусу жалобы
         * @param {string} [senderEmail] Фильтр по email отправителя (точное совпадение)
         * @param {string} [sort] Сортировка (по умолчанию по дате создания, убывание)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getComplaints(page?: number, size?: number, status?: ComplaintStatus, senderEmail?: string, sort?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComplaintPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getComplaints(page, size, status, senderEmail, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComplaintsApi.getComplaints']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Обновляет жалобу (только для администраторов). Позволяет изменить статус и добавить комментарий. 
         * @summary Обновить жалобу
         * @param {number} id ID жалобы
         * @param {UpdateComplaintRequest} updateComplaintRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateComplaint(id: number, updateComplaintRequest: UpdateComplaintRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComplaintDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateComplaint(id, updateComplaintRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComplaintsApi.updateComplaint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ComplaintsApi - factory interface
 * @export
 */
export const ComplaintsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ComplaintsApiFp(configuration)
    return {
        /**
         * Закрывает жалобу с переводом в статус FIXED или SKIPPED. Требует обязательный комментарий разработчика. 
         * @summary Закрыть жалобу
         * @param {number} id ID жалобы
         * @param {CloseComplaintRequest} closeComplaintRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeComplaint(id: number, closeComplaintRequest: CloseComplaintRequest, options?: RawAxiosRequestConfig): AxiosPromise<CloseComplaintResponse> {
            return localVarFp.closeComplaint(id, closeComplaintRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Создаёт новую жалобу от пользователя. Публичный endpoint без аутентификации. Жалоба автоматически ставится в очередь отправки в поддержку. 
         * @summary Создать жалобу
         * @param {CreateComplaintRequest} createComplaintRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComplaint(createComplaintRequest: CreateComplaintRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateComplaintResponse> {
            return localVarFp.createComplaint(createComplaintRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Получает детальную информацию о жалобе по ID. Включает полный текст жалобы и комментарий разработчика. 
         * @summary Получить жалобу по ID
         * @param {number} id ID жалобы
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComplaintById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ComplaintDetailResponse> {
            return localVarFp.getComplaintById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Пагинированный список жалоб для администраторов. Возвращает только метаданные без полного текста жалоб. 
         * @summary Получить список жалоб
         * @param {number} [page] Номер страницы (начиная с 0)
         * @param {number} [size] Размер страницы (максимум 100)
         * @param {ComplaintStatus} [status] Фильтр по статусу жалобы
         * @param {string} [senderEmail] Фильтр по email отправителя (точное совпадение)
         * @param {string} [sort] Сортировка (по умолчанию по дате создания, убывание)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComplaints(page?: number, size?: number, status?: ComplaintStatus, senderEmail?: string, sort?: string, options?: RawAxiosRequestConfig): AxiosPromise<ComplaintPageResponse> {
            return localVarFp.getComplaints(page, size, status, senderEmail, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * Обновляет жалобу (только для администраторов). Позволяет изменить статус и добавить комментарий. 
         * @summary Обновить жалобу
         * @param {number} id ID жалобы
         * @param {UpdateComplaintRequest} updateComplaintRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateComplaint(id: number, updateComplaintRequest: UpdateComplaintRequest, options?: RawAxiosRequestConfig): AxiosPromise<ComplaintDetailResponse> {
            return localVarFp.updateComplaint(id, updateComplaintRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ComplaintsApi - object-oriented interface
 * @export
 * @class ComplaintsApi
 * @extends {BaseAPI}
 */
export class ComplaintsApi extends BaseAPI {
    /**
     * Закрывает жалобу с переводом в статус FIXED или SKIPPED. Требует обязательный комментарий разработчика. 
     * @summary Закрыть жалобу
     * @param {number} id ID жалобы
     * @param {CloseComplaintRequest} closeComplaintRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplaintsApi
     */
    public closeComplaint(id: number, closeComplaintRequest: CloseComplaintRequest, options?: RawAxiosRequestConfig) {
        return ComplaintsApiFp(this.configuration).closeComplaint(id, closeComplaintRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Создаёт новую жалобу от пользователя. Публичный endpoint без аутентификации. Жалоба автоматически ставится в очередь отправки в поддержку. 
     * @summary Создать жалобу
     * @param {CreateComplaintRequest} createComplaintRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplaintsApi
     */
    public createComplaint(createComplaintRequest: CreateComplaintRequest, options?: RawAxiosRequestConfig) {
        return ComplaintsApiFp(this.configuration).createComplaint(createComplaintRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Получает детальную информацию о жалобе по ID. Включает полный текст жалобы и комментарий разработчика. 
     * @summary Получить жалобу по ID
     * @param {number} id ID жалобы
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplaintsApi
     */
    public getComplaintById(id: number, options?: RawAxiosRequestConfig) {
        return ComplaintsApiFp(this.configuration).getComplaintById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Пагинированный список жалоб для администраторов. Возвращает только метаданные без полного текста жалоб. 
     * @summary Получить список жалоб
     * @param {number} [page] Номер страницы (начиная с 0)
     * @param {number} [size] Размер страницы (максимум 100)
     * @param {ComplaintStatus} [status] Фильтр по статусу жалобы
     * @param {string} [senderEmail] Фильтр по email отправителя (точное совпадение)
     * @param {string} [sort] Сортировка (по умолчанию по дате создания, убывание)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplaintsApi
     */
    public getComplaints(page?: number, size?: number, status?: ComplaintStatus, senderEmail?: string, sort?: string, options?: RawAxiosRequestConfig) {
        return ComplaintsApiFp(this.configuration).getComplaints(page, size, status, senderEmail, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Обновляет жалобу (только для администраторов). Позволяет изменить статус и добавить комментарий. 
     * @summary Обновить жалобу
     * @param {number} id ID жалобы
     * @param {UpdateComplaintRequest} updateComplaintRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplaintsApi
     */
    public updateComplaint(id: number, updateComplaintRequest: UpdateComplaintRequest, options?: RawAxiosRequestConfig) {
        return ComplaintsApiFp(this.configuration).updateComplaint(id, updateComplaintRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



